export default __webpack_public_path__ + "40ec3186bcab532502f7e883ba872823.png";